function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var TableExpandHeader = function TableExpandHeader(props) {
  return React.createElement("th", _extends({
    scope: "col"
  }, props));
};

export default TableExpandHeader;


//////////////////
// WEBPACK FOOTER
// ./node_modules/carbon-components-react/es/components/DataTable/TableExpandHeader.js
// module id = 1247
// module chunks = 0